module.exports = __webpack_public_path__ + "static/media/icon-adNoBorder.3e8d48fa.svg";